<script setup>
import { onBeforeMount, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

// import logoXD from "@/assets/img/small-logos/logo-xd.svg";
// import logoAtlassian from "@/assets/img/small-logos/logo-atlassian.svg";
// import logoSlack from "@/assets/img/small-logos/logo-slack.svg";
// import logoSpotify from "@/assets/img/small-logos/logo-spotify.svg";
// import logoJira from "@/assets/img/small-logos/logo-jira.svg";
// import logoInvision from "@/assets/img/small-logos/logo-invision.svg";
//
// import team1 from "@/assets/img/team-1.jpg";
// import team2 from "@/assets/img/team-2.jpg";
// import team3 from "@/assets/img/team-3.jpg";
// import team4 from "@/assets/img/team-4.jpg";

const store = useStore();

onBeforeMount(() => {
  store.state.isRTL = true;
  document.querySelector("html").setAttribute("lang", "ar");
  document.querySelector("html").setAttribute("dir", "rtl");
  document.querySelector("#app").classList.add("rtl");
});
onBeforeUnmount(() => {
  store.state.isRTL = false;
  document.querySelector("html").removeAttribute("lang");
  document.querySelector("html").removeAttribute("dir");
  document.querySelector("#app").classList.remove("rtl");
});
</script>
<template>
  <div class="py-4 container-fluid ">
    <div class="row bg-body">
      <div class="col-lg-7 mb-lg-0 mb-4">
        <h2>dashboard content</h2>
      </div>

    </div>

  </div>
</template>
